import { defineMessages } from 'react-intl';

export default defineMessages({
    DoYouKnow: {
        id: 'qnb.SgOtherProducts.DoYouKnow',
        defaultMessage: 'Do you know we also provide these products?'
    },
    FindOutMore: {
        id: 'qnb.SgOtherProducts.FindOutMore',
        defaultMessage: 'Find out more'
    },
    CarInsuranceHeader: {
        id: 'qnb.SgOtherProducts.CarInsuranceHeader',
        defaultMessage: 'Car Insurance'
    },
    HomeInsuranceHeader: {
        id: 'qnb.SgOtherProducts.HomeInsuranceHeader',
        defaultMessage: 'Home Insurance'
    },
    HealthInsuranceHeader: {
        id: 'qnb.SgOtherProducts.HealthInsuranceHeader',
        defaultMessage: 'Health insurance'
    },
    TravelInsuranceHeader: {
        id: 'qnb.SgOtherProducts.TravelInsuranceHeader',
        defaultMessage: 'Travel insurance'
    }
});
